import { useMutation } from 'react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import type { DownloadCuiAuditQueryVars } from './types';

export const useDownloadCuiAudit: MutationFunction<
  string,
  DownloadCuiAuditQueryVars
> = ({ requestOptions, queryOptions } = {}) => {
  const urlPath = `/suppliers/cui_event_audit_download`;
  const request = useRequest(requestOptions);

  return useMutation(
    (requestData) => {
      return request(urlPath, {
        init: {
          method: 'GET',
        },
        query: requestData,
      });
    },
    {
      ...queryOptions,
      mutationKey: ['groups', 'downloadCuiAudit'],
    },
  );
};
